import { Injectable } from '@angular/core';
import { filter } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { adUserSelectors, userProfileHelpers } from '@content-platform/web-angular-administration-shared-data-access-graph-api';
import { endpointNeedsAdalToken } from '../helpers/endpoint-helper';
import { DebugFlagsService } from '@content-platform/web-angular-shared-util-development';
import { IpAddressService } from '@content-platform/web-angular-shared-util-logging';
import { REMOVE_CONTENT_PLATFORM_USER_HEADER } from '../debug-flags';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@content-platform/web-angular-shared-util-logging";
import * as i3 from "@content-platform/web-angular-shared-util-development";
/**
 * Interceptor for adding user details to outgoing requests
 *
 * @export
 * @class ContentPlatformUserService
 */
export class ContentPlatformUserService {
    constructor(store, ipAddressService, debugFlags) {
        this.store = store;
        this.ipAddressService = ipAddressService;
        this.debugFlags = debugFlags;
        this.userHeaderInfo = {};
        this.gotUserInfo = false;
        this.hasRequestedIpAddress = false;
        this.store
            .pipe(select(adUserSelectors.getCurrentUserProfile), filter(currentUser => !!currentUser))
            .subscribe(currentUser => {
            this.gotUserInfo = true;
            this.userHeaderInfo = this.getUserHeader(currentUser);
        });
    }
    getUserHeader(currentUser) {
        return {
            ...this.userHeaderInfo,
            userName: currentUser.displayName,
            email: currentUser.mail,
            userType: userProfileHelpers.getUserType(currentUser),
            id: currentUser.objectId
        };
    }
    intercept(request, next) {
        // As this request must have happened after app bootstrap, we can safely request the IP address
        this.requestIPAddressForHeaderInfoIfNeeded();
        if (this.debugFlags.hasDebugFlag(REMOVE_CONTENT_PLATFORM_USER_HEADER) ||
            !endpointNeedsAdalToken(request) ||
            !this.gotUserInfo) {
            return next.handle(request);
        }
        return next.handle(this.setContentPlatforUserHeader(request));
    }
    setContentPlatforUserHeader(request) {
        const userHeaderInfo = JSON.parse(JSON.stringify(this.userHeaderInfo));
        userHeaderInfo.userName = this.normalizeText(userHeaderInfo.userName);
        return request.clone({
            setHeaders: {
                'Content-Platform-User': JSON.stringify(userHeaderInfo)
            }
        });
    }
    /**
     * This method should NOT be called from the constructor, as that causes a circular dependency
     *
     * @private
     * @returns {void}
     * @memberof ContentPlatformUserService
     */
    requestIPAddressForHeaderInfoIfNeeded() {
        if (this.hasRequestedIpAddress ||
            !this.ipAddressService ||
            !this.ipAddressService.ipAddressAsync) {
            // Either the IP address service has not initialized yet and we can't subscribe to the ipAddress observable, or
            // we've already initiated a request to get the IP address, don't do it again
            return;
        }
        this.hasRequestedIpAddress = true;
        this.ipAddressService.ipAddressAsync.subscribe(ipAddress => {
            this.userHeaderInfo = {
                ...this.userHeaderInfo,
                ipAddress
            };
        });
    }
    /**
     * This method is to normalize string
     *
     * @private
     * @returns {string}
     * @memberof ContentPlatformUserService
     */
    normalizeText(text) {
        return text.normalize('NFKD').replace(/[^\w, ]/g, '');
    }
    static { this.ɵfac = function ContentPlatformUserService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ContentPlatformUserService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.IpAddressService), i0.ɵɵinject(i3.DebugFlagsService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ContentPlatformUserService, factory: ContentPlatformUserService.ɵfac }); }
}
//# sourceMappingURL=content-platform-user.service.js.map